__webpack_require__.p = "/Vtech-Ventures-Site/";